import React from "react";
import contactimage from "../../../assets/media/img/contact-image.svg";
import { useNavigate } from "react-router";
const ContactForm = () => {
  const Nav = useNavigate();
  return (
    <section className="section first-section | md:pt-[105px] md:pb-94px md:px-30px | pt-[105px] pb-64px px-20px">
      <div className="section-container contact-form | flex md:justify-between justify-center items-center max-w-[1260px] m-auto">
        <div className="left-side">
          <div className="contact-form-container | w-full">
            <form className="md:p-48px | sm:p-30px p-0 " action="">
              <h1 className="md:text-4xl | text-3xl font-semibold m-0 mb-10px text-primary-900">
                Get in touch
              </h1>
              <h5 className="md:text-xl md:mb-32px | text-lg m-0 mb-20px font-light text-accent-400">
                Our friendly team would love to hear from you.
              </h5>
              <div className="input-row | flex md:gap-32px gap-20px justify-between">
                <div className="labled-input | md:mb-25px mb-16px flex w-full flex-col gap-2">
                  <label className="m-0 text-accent-300 text-sm">
                    First name
                  </label>
                  <input
                    className="font-semibold flex focus-within:outline-primary-500 outline-2 focus-within:outline w-full box-border rounded-lg border border-accent-200 shadow-sm overflow-hidden text-primary-800 outline-none py-10px px-16px text-base"
                    type="text"
                    placeholder="First name"
                  />
                </div>
                <div className="labled-input | md:mb-25px mb-16px flex w-full flex-col gap-2">
                  <label className="m-0 text-accent-300 text-sm">
                    Last name
                  </label>
                  <input
                    className=" font-semibold flex focus-within:outline-primary-500 outline-2 focus-within:outline w-full box-border rounded-lg border border-accent-200 shadow-sm overflow-hidden text-primary-800 outline-none py-10px px-16px text-base"
                    type="text"
                    placeholder="Last name"
                  />
                </div>
              </div>
              <div className="labled-input | md:mb-25px mb-16px flex w-full flex-col gap-2">
                <label className="m-0 text-accent-300 text-sm">Email</label>
                <input
                  className=" font-semibold flex focus-within:outline-primary-500 outline-2 focus-within:outline w-full box-border rounded-lg border border-accent-200 shadow-sm overflow-hidden text-primary-800 outline-none py-10px px-16px text-base"
                  type="text"
                  placeholder="you@email.com"
                />
              </div>
              <div className="labled-input | md:mb-25px mb-16px flex w-full flex-col gap-2">
                <label className="m-0 text-accent-300 text-sm">Phone</label>
                <input
                  className=" font-semibold flex focus-within:outline-primary-500 outline-2 focus-within:outline w-full box-border rounded-lg border border-accent-200 shadow-sm overflow-hidden text-primary-800 outline-none py-10px px-16px text-base"
                  type="text"
                  placeholder="+1(555) 000-0000"
                />
              </div>
              <div className="labled-input | md:mb-25px mb-16px flex w-full flex-col gap-2">
                <label className="m-0 text-accent-300 text-sm">Message</label>
                <textarea
                  className="outline-none border border-accent-200 shadow-sm resize-none py-12px px-16px rounded-lg font-semibold text-primary-900 focus-within:outline-primary-500 outline-2"
                  placeholder="Write your message here "
                  rows="10"
                ></textarea>
              </div>
              <div className="check-row | flex items-center mb-20px gap-16px text-accent-400 text-base">
                <label className="customized-checkbox">
                  <input type="checkbox" id="privacy-policy" />
                  <svg viewBox="0 0 21 18">
                    <symbol
                      id="tick-path"
                      viewBox="0 0 21 18"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.22003 7.26C5.72003 7.76 7.57 9.7 8.67 11.45C12.2 6.05 15.65 3.5 19.19 1.69"
                        fill="none"
                        strokeWidth="2.25"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </symbol>
                    <defs>
                      <mask id="tick">
                        <use className="tick mask" href="#tick-path" />
                      </mask>
                    </defs>
                    <use
                      className="tick"
                      href="#tick-path"
                      stroke="currentColor"
                    />
                    <path
                      fill="white"
                      mask="url(#tick)"
                      d="M18 9C18 10.4464 17.9036 11.8929 17.7589 13.1464C17.5179 15.6054 15.6054 17.5179 13.1625 17.7589C11.8929 17.9036 10.4464 18 9 18C7.55357 18 6.10714 17.9036 4.85357 17.7589C2.39464 17.5179 0.498214 15.6054 0.241071 13.1464C0.0964286 11.8929 0 10.4464 0 9C0 7.55357 0.0964286 6.10714 0.241071 4.8375C0.498214 2.39464 2.39464 0.482143 4.85357 0.241071C6.10714 0.0964286 7.55357 0 9 0C10.4464 0 11.8929 0.0964286 13.1625 0.241071C15.6054 0.482143 17.5179 2.39464 17.7589 4.8375C17.9036 6.10714 18 7.55357 18 9Z"
                    />
                  </svg>
                  <svg className="lines" viewBox="0 0 11 11">
                    <path d="M5.88086 5.89441L9.53504 4.26746" />
                    <path d="M5.5274 8.78838L9.45391 9.55161" />
                    <path d="M3.49371 4.22065L5.55387 0.79198" />
                  </svg>
                </label>
                <label className="m-0" htmlFor="privacy-policy">
                  You agree to our friendly{" "}
                  <span
                    className="text-primary-500 font-medium underline"
                    onClick={() => {
                      Nav("/policies");
                    }}
                  >
                    privacy policy
                  </span>
                  .
                </label>
              </div>
              <button className="w-full p-12px font-medium text-white bg-primary-500 rounded-lg border-none outline-none cursor-pointer duration-300 hover:opacity-90 mt-10px">
                Send message
              </button>
            </form>
          </div>
        </div>
        <div className="right-side md:flex hidden">
          <img className="w-full max-w-[500px]" src={contactimage} alt="" />
        </div>
      </div>
    </section>
  );
};
export default ContactForm;
